import { useHistory } from 'react-router-dom';
import UserForm from 'forms/UserForm';

export default (): JSX.Element => {
  const history = useHistory();

  return <UserForm onSuccess={() => history.go(-1)} />;
};
